import { Box, Typography } from '@mui/material';
import StepComponent from './step.component';
import { getBatteryDefaultDetails, getBatteryDefinitionFromBrandModel } from '../../shared/device-details-utils';
import { get } from 'lodash';
import StepContainer from './step-container.component';
import { STEP_IDS } from '../config-wizard-steps';

const hiddenErrorNames = new Set(['const', 'enum', 'oneOf']);

function transformBrandModelErrors(errors) {
  const filterOutHiddenErrorNames = (error) => !error.name || !hiddenErrorNames.has(error.name);

  return errors.filter(filterOutHiddenErrorNames);
}

export default function BatteryPanelsStep({ stepProps, onChange, ...props }) {
  const { formData, schema, uiSchema } = stepProps;

  const batteryBrandModelProps = {
    ...stepProps,
    formData: { batteryBrandModel: formData?.batteryBrandModel },
    schema: schema.batteryBrandModel,
    uiSchema: uiSchema.batteryBrandModel,
    liveValidate: true,
    skipContainer: true,
    transformErrors: transformBrandModelErrors,
    formContext: {
      diffObj: { batteryBrandModel: stepProps.formContext.diffObj.batteryBrandModel },
    },
  };

  const batteryProps = {
    ...stepProps,
    helperText: null,
    formData: {
      battery: formData?.battery,
    },
    schema: {
      ...schema.battery,
      properties: {
        battery: schema.battery.properties.battery,
      },
    },
    uiSchema: uiSchema.battery,
    liveValidate: true,
    skipContainer: true,
    formContext: {
      diffObj: { battery: stepProps.formContext.diffObj.battery },
    },
    experimental_defaultFormStateBehavior: {
      emptyObjectFields: 'populateAllDefaults',
      allOf: 'populateDefaults',
    },
  };

  const onBatteryBrandModelChange = (stepId, formRef) => (key) => {
    const { batteryBrandModel } = get(formRef, 'current.state.formData', {});

    if (!batteryBrandModel) {
      return;
    }

    const batteryDefinition = getBatteryDefinitionFromBrandModel(props.schemas, batteryBrandModel);

    if (!batteryDefinition) {
      return;
    }

    const defaultBattery = getBatteryDefaultDetails(batteryDefinition);

    onChange(stepId, formRef, {
      battery: defaultBattery,
    })(key);
  };

  const onBatteryChange = (stepId, formRef) => (key) => {
    onChange(stepId, formRef, {
      batteryBrandModel: stepProps.formData?.batteryBrandModel,
    })(key);
  };

  const { brand, model } = props.state.get(STEP_IDS.CONVERTER) || {};

  const batteryNotApplicable = !(brand && model) && props.CONVERTER?.brand === 'DefaultInverter';

  return (
    <StepContainer>
      {batteryNotApplicable ? (
        <Typography
          variant="body"
          fontWeight={500}
        >
          ℹ️ Mind: To configure Battery, an inverter must be configured first
        </Typography>
      ) : (
        <>
          <Box>
            <StepComponent
              {...props}
              onChange={onBatteryBrandModelChange}
              partialKey="batteryBrandModel"
              stepProps={batteryBrandModelProps}
            />
          </Box>
          <Box>
            <StepComponent
              {...props}
              onChange={onBatteryChange}
              partialKey="battery"
              stepProps={batteryProps}
            />
          </Box>
        </>
      )}
    </StepContainer>
  );
}
